import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { KinesisContainer, KinesisElement } from 'vue-kinesis'
import VueConfetti from 'vue-confetti'

Vue.component('kinesis-container', KinesisContainer)
Vue.component('kinesis-element', KinesisElement)
Vue.use(VueConfetti)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
